import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { reportPost } from "../../../redux/posts/action";

const wrapStyle = {
  position: "absolute",
  top: "12px",
  right: "12px",
  zIndex: 15,
};

const menuStyle = {
  position: "absolute",
  top: "calc(100% + 4px)",
  right: 0,
  background: "#fff",
  border: "1px solid #eee",
  borderRadius: "8px",
  boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
  minWidth: "120px",
  zIndex: 20,
  overflow: "hidden",
};

export default function PostReportMenu({ item, masterType }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [reporting, setReporting] = useState(false);
  const [hoverToggle, setHoverToggle] = useState(false);
  const [hoverItem, setHoverItem] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  if (!item || item?.is_mine == 1 || !masterType) return null;

  const handleReport = async (e) => {
    e.stopPropagation();
    if (reporting) return;
    setReporting(true);
    await dispatch(reportPost(item?.id, masterType));
    setReporting(false);
    setOpen(false);
  };

  return (
    <div style={wrapStyle} ref={wrapRef} onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        aria-label="Post options"
        style={{
          border: "none",
          background: hoverToggle ? "#F3F3F3" : "transparent",
          padding: "4px 8px",
          borderRadius: "50%",
          cursor: "pointer",
          fontSize: "16px",
          lineHeight: 1,
          color: "#555",
        }}
        onMouseEnter={() => setHoverToggle(true)}
        onMouseLeave={() => setHoverToggle(false)}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
      >
        <i className="fa-solid fa-ellipsis-vertical"></i>
      </button>
      {open && (
        <div style={menuStyle}>
          <a
            style={{
              display: "block",
              padding: "10px 16px",
              color: "#DE311E",
              fontSize: "14px",
              cursor: reporting ? "default" : "pointer",
              whiteSpace: "nowrap",
              background: hoverItem ? "#FFF2E7" : "transparent",
            }}
            onMouseEnter={() => setHoverItem(true)}
            onMouseLeave={() => setHoverItem(false)}
            onClick={handleReport}
          >
            {reporting ? "Reporting..." : "Report"}
          </a>
        </div>
      )}
    </div>
  );
}
